export const deepClone = <T>(initialValue: T): T => {
  return JSON.parse(JSON.stringify(initialValue));
};
